import { render, staticRenderFns } from "./AddOrEditTemplateInfo.vue?vue&type=template&id=1e770b04&scoped=true"
import script from "./AddOrEditTemplateInfo.vue?vue&type=script&lang=js"
export * from "./AddOrEditTemplateInfo.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditTemplateInfo.vue?vue&type=style&index=0&id=1e770b04&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e770b04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e770b04')) {
      api.createRecord('1e770b04', component.options)
    } else {
      api.reload('1e770b04', component.options)
    }
    module.hot.accept("./AddOrEditTemplateInfo.vue?vue&type=template&id=1e770b04&scoped=true", function () {
      api.rerender('1e770b04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/questionnaire/template/sub/AddOrEditTemplateInfo.vue"
export default component.exports